export function sendMessage(type, data) {
    const message = { type: type, ...data };
    console.log('Sending message:', message);
    parent.postMessage(JSON.stringify(message), '*');
    if (window.top !== window.parent) {
        window.top.postMessage(JSON.stringify(message), '*');
    }
}

export function sendResize() {
    sendMessage('resize', { height: document.body.scrollHeight });
}

export function sendScrollTop() {
    window.scrollTo(0, 0);
    sendMessage('scrollTop');
}

export function sendScrollTo(y) {
    sendMessage('scrollTo', { position: y });
}
